import React from 'react'
import clsx from 'clsx'

function jobStatusBadgeColor(status) {
  if (!status) return 'bg-surface-variant text-outline'
  const s = String(status).toUpperCase()
  if (s === 'COMPLETED') return 'bg-emerald-50 border border-emerald-500 text-emerald-700'
  if (s === 'IN_PROGRESS' || s === 'IN PROGRESS') return 'bg-blue-50 border border-blue-500 text-blue-700'
  if (s === 'ON_HOLD' || s === 'ON HOLD') return 'bg-amber-50 border border-amber-500 text-amber-700'
  if (s === 'PENDING_REVIEW' || s === 'PENDING REVIEW') return 'bg-purple-50 border border-purple-500 text-purple-700'
  if (s === 'CLOSED') return 'bg-slate-100 border border-slate-400 text-slate-700'
  return 'bg-blue-50 border border-primary text-primary'
}

export default function JobPoolPanel({
  jobPool = [],
  jobs = [],
  isLoading = false,
  onDragStart,
  onDragEnd,
}) {
  const items = jobPool.length > 0 ? jobPool : jobs

  return (
    <div className="col-span-12 lg:col-span-3 flex flex-col h-full">
      <div className="bg-surface-container-lowest rounded-[22px] p-6 border border-outline-variant/20 flex flex-col shadow-sm h-full">
        {/* Header */}
        <div className="flex flex-col mb-4">
          <div className="flex items-center justify-between">
            <h3 className="font-headline font-bold text-on-surface text-base">Job Pool</h3>
            <span className="bg-surface-container-high text-[10px] font-bold px-2.5 py-1 rounded-lg text-outline uppercase tracking-tight">
              {items.length} BACKLOG
            </span>
          </div>
          <p className="text-[11px] text-outline mt-0.5">Unassigned Jobs &bull; Based on Jobs</p>
        </div>

        {isLoading && (
          <div className="text-sm text-on-surface-variant py-4 text-center">Loading jobs...</div>
        )}

        <div className="space-y-4 task-pool-scroll pr-1 custom-scrollbar flex-1">
          {items.map((job) => {
            const statusUpper = String(job.status || 'DRAFT').toUpperCase()
            const borderCls =
              statusUpper === 'IN_PROGRESS' || statusUpper === 'IN PROGRESS'
                ? 'border-l-blue-600'
                : statusUpper === 'COMPLETED'
                ? 'border-l-emerald-600'
                : statusUpper === 'ON_HOLD' || statusUpper === 'ON HOLD'
                ? 'border-l-amber-500'
                : 'border-l-primary'

            return (
              <div
                key={job.job_id}
                draggable
                onDragStart={() => onDragStart && onDragStart(job)}
                onDragEnd={onDragEnd}
                className={clsx(
                  'p-4 rounded-xl bg-surface-container-low border-l-4 hover:shadow-md transition-all cursor-grab active:cursor-grabbing group',
                  borderCls,
                )}
              >
                <div className="flex justify-between items-start mb-2">
                  <span
                    className={clsx(
                      'font-label text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full',
                      jobStatusBadgeColor(job.status),
                    )}
                  >
                    {job.status || 'DRAFT'}
                  </span>
                  <span className="text-[10px] font-bold text-on-surface-variant">
                    {job.planned_hours ? `${job.planned_hours}h` : '—'}
                  </span>
                </div>
                <h4 className="font-bold text-sm text-on-surface group-hover:text-primary transition-colors leading-snug">
                  {job.job_name}
                </h4>
                {job.task_name && (
                  <p className="text-[11px] font-medium text-on-surface-variant mt-1 truncate">
                    <span className="text-outline">Task:</span> {job.task_name}
                  </p>
                )}
                {job.project_name && (
                  <p className="text-[11px] text-outline truncate">
                    <span className="text-outline">Project:</span> {job.project_name}
                  </p>
                )}
                <div className="mt-3 flex items-center gap-2">
                  <span className="material-symbols-outlined text-xs text-outline select-none">
                    drag_indicator
                  </span>
                  <span className="text-[10px] text-outline">drag to employee row</span>
                </div>
              </div>
            )
          })}

          {!isLoading && items.length === 0 && (
            <div className="rounded-xl bg-surface-container-low p-4 text-center text-sm text-on-surface-variant">
              No unassigned jobs in pool.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
